export const RESOURCE_TEXT_FIELD_MIN_LENGTH = 2;
export const RESOURCE_TEXT_FIELD_MAX_LENGTH = 255;
